<template>
    <div class="list-raovat">
        <!-- khối fillter và xử lý muti -->
        <actionTable
            :idSelect="idSelect"
            v-model="data_fillter"/>
        <!-- table list rao vặt -->
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web'
            }">
            <!-- thead web -->
            <thead v-if="$detect == 'web'">
                <tr>
                    <th scope="col" class="text-center">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                                id="select-all-table" v-model="selectAll"/>
                            <label class="custom-control-label" for="select-all-table"></label>
                        </div>
                    </th>
                    <th scope="col" class="text-center">Ảnh</th>
                    <th scope="col">Tiều đề</th>
                    <th scope="col">Lượt xem</th>
                    <th scope="col">Giá</th>
                    <th scope="col" class="text-center">Cập nhật</th>
                    <th scope="col" class="text-center">Trạng thái</th>
                    <th scope="col" class="text-center">Thao tác</th>
                </tr>
            </thead>
            <!-- hết thead web -->

            <!-- thead mobile -->
            <thead v-else>
                <tr>
                    <th scope="col" class="text-center py-1">
                        <span class="check-all-mobile" @click="selectAll = !selectAll">
                            <img :src="selectAll ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                        </span>
                    </th>
                    <th scope="col" class="text-center py-1">Thông tin</th>
                </tr>
            </thead>
            <!-- hết thead mobile -->

            <!-- tbody -->

            <!-- check xem có dữliệu hay không -->
            <tbody v-if="raovat.length == 0">
                <tr>
                    <td colspan="8" class="text-center text-muted">Không có dữ liệu</td>
                </tr>
            </tbody>

            <!-- có dữ liệu -->
            <!-- tbody web -->
            <tbody v-else-if="$detect == 'web'">
                <tr :class="{
                        'position-relative': true,
                        'pending': item.status != 1 || item.status == 1 && item.status_expire === 0
                    }" v-for="(item,index) in raovat" :key="index">
                    <!-- td checkbox -->
                    <td scope="row" style="white-space: nowrap;">
                        <div class="custom-control custom-checkbox text-center"
                            v-if="item.status == 1 && item.status_expire === 1">
                            <input type="checkbox" class="custom-control-input"
                                :id="item.id" :value="item.id" v-model="idSelect"/>
                            <label class="custom-control-label" :for="item.id"></label>
                        </div>
                    </td>
                    <!-- td ảnh rao vặt -->
                    <td width="50" class="position-relative">
                        <img class="img-web" :src="item.image" onerror="errorImage(this)"/>
                        <div class="position-absolute w-100 h-100"
                            style="top: 0; left: 0; background: #f6f6f65c;"
                            v-if="item.status != 1 || (item.status == 1 && item.status_expire === 0)">
                        </div>
                    </td>
                    <!-- td tiêu đề, id, link -->
                    <td class="name-rv">
                        <div>
                            <span class="pr-2 id-table">#{{item.id}}</span>
                            <a class="text-decoration-none" :href="$linkUrl(item.link)" target="_blank">
                                <span class="name-item">{{item.name}}</span>
                            </a>
                        </div>
                    </td>
                    <!-- td lượt xem -->
                    <td class="hit-rv" width="100">
                        <div class="text-center" v-if="item.status == 1">{{ $formatNumber(item.hit) }}</div>
                    </td>
                    <!-- td giá tin rao -->
                    <td width="100" class="position-relative">
                        <div v-html="item.price"
                            :style="`font-weight: 600; ${item.status == 1 && item.status_expire == 1 ?  'color: #e74c3c' : 'color: #909399'}`">
                        </div>
                        <div class="hover-action-table position-absolute bg-white"
                            v-if="item.status == 1 && item.status_expire == 1">
                            <div class="d-flex flex-wrap">
                                <!-- check xem là có loading và loadingAction -->
                                <div class="w-33 pt-1">
                                    <button class="w-100 border-0 text-white rounded-lg p-5px fs-14px btn-hover-action up-news"
                                        @click="upTop(item, index)" :disabled="index === loading && loadingAction == 'up-top'">
                                        Up lên đầu
                                    </button>
                                </div>
                                <div class="w-33 pt-1 mx-10px">
                                    <button class="w-100 border-0 text-white rounded-lg p-5px fs-14px btn-hover-action auto-up"
                                        @click="autoUp(item)">
                                        Tự động Up
                                    </button>
                                </div>
                                <div class="w-33 pt-1">
                                    <!-- check xem là có loading và loadingAction -->
                                    <button class="w-100 border-0 text-white rounded-lg p-5px fs-14px btn-hover-action up-time"
                                        @click="availability(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                                        Gia hạn
                                    </button>
                                </div>
                                <div class="w-33 pt-1">
                                    <button class="w-100 border-0 text-white rounded-lg p-5px fs-14px btn-hover-action up-vip"
                                        @click="actionUpItem(item, 'vip')">
                                        VIP
                                    </button>
                                </div>
                                <div class="w-33 pt-1 mx-10px">
                                    <button class="w-100 border-0 text-white rounded-lg p-5px fs-14px btn-hover-action up-svip"
                                        @click="actionUpItem(item, 'supper-vip')">
                                        Siêu VIP
                                    </button>
                                </div>
                            </div>
                        </div>
                    </td>
                    <!-- td ngày update -->
                    <td width="140" class="text-center">
                        <div v-if="item.status == 1 && item.status_expire == 0">
                            <button type="button" class="btn btn-primary btn-sm"
                                @click="availability(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                                Gia hạn ngay
                            </button>
                        </div>
                        <div v-else>
                            {{
                                (item.last_up != 0 ? item.last_up : item.post_date).split(' ')[0]
                            }}
                            <br/>
                            <span :style="`font-size: 12px; ${item.status == 1 && item.status_expire == 1 ? 'color: #666;': 'color: #909399'}`">
                                {{
                                    (item.last_up != 0 ? item.last_up : item.post_date).split(' ')[1]
                                }}
                            </span>
                        </div>
                    </td>
                    <td width="120" class="text-center">
                        <div v-if="item.status == 1"
                            :class="{
                                'fw-600 text-success':item.status_expire === 1
                            }">
                            {{item.status_expire === 1 ? 'Đã duyệt' : 'Hết hạn'}}
                        </div>
                        <div v-else :class="{
                            'text-danger fw-600': item.status == 2
                        }">{{item.status_text}}</div>
                        <div style="font-size: 12px;cursor: pointer; text-decoration: underline;"
                            v-if="item.status == 2" class="mt-1" @click="approve = item, dialogApprove = true">Xem lý do</div>
                    </td>
                    <td width="150" class="text-center">
                        <button type="button" class="btn btn-success btn-sm px-3 mr-2"
                            @click="!(item.status == 1 && item.status_expire === 0) ? update(item.id) : ''"
                            :disabled="item.status == 1 && item.status_expire === 0">
                            <i class="icon ion-md-create"></i>
                        </button>
                        <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destroy(item)">
                            <i class="icon ion-md-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <!-- hết tbody web -->

            <!-- tbody mobile -->
            <tbody v-else>
                <tr :class="{
                        'table-mobile position-relative': true,
                        'pending': item.status != 1 || item.status == 1 && item.status_expire === 0
                    }" v-for="(item, index) in raovat" :key="index">
                    <!-- td ảnh và checkbox -->
                    <td class="img-tab position-relative pl-1">
                        <div class="checkbox-mobile position-absolute"
                            v-if="item.status == 1 && item.status_expire === 1">
                            <input type="checkbox" class="d-none" v-model="idSelect"
                                :value="item.id" :id="item.id"/>
                            <label class="checkbox-label" :for="item.id">
                                <img :src="idSelect.includes(item.id) ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                            </label>
                        </div>
                        <!-- chỉ cần click vào img là được checkbox -->
                        <div class="position-relative">
                            <img :src="item.image" onerror="errorImage(this)" @click="pushIdMuti(item)"/>
                            <div class="position-absolute w-100 h-100"
                                style="top: 0; left: 0; background: #f6f6f65c;"
                                v-if="item.status != 1 || item.status == 1 && item.status_expire === 0">
                            </div>
                        </div>
                    </td>
                    <!-- td thông tin -->
                    <!-- click thông tin là show model xử lý -->
                    <!-- <td style="width: calc(100% - 100px)" @click="actionItem(item)"> -->
                    <td  :width="widthTable - 100" class="position-relative"
                        @click="activeTr = index">
                        <div class="name">{{item.name}}</div>
                        <div class="d-flex justify-content-between mt-2">
                            <div class="price-tab" v-html="item.price"></div>
                            <div class="fs-14px" v-if="item.status == 1"><i class="icon ion-md-eye mr-1"></i>{{ $formatNumber(item.hit) }}</div>
                        </div>
                        <div class="d-flex justify-content-between mt-2 d-none">
                            <div class="time-table">
                                <i class="icon ion-md-time mr-1"></i>
                                <span class="time">{{item.last_up != 0 ? item.last_up : item.post_date}}</span>
                            </div>
                            <span v-if="screenWidth > 320"
                                :class="{
                                    'text-right': true,
                                    'text-success': item.status == 1 && item.status_expire == 1,
                                    'text-danger': item.status == 2,
                                }">
                                <div v-if="item.status == 1">
                                    {{item.status_expire === 1 ? 'Đã duyệt' : 'Hết hạn'}}
                                </div>
                                <div v-else>{{item.status_text}}</div>
                            </span>
                        </div>
                        <div class="mt-2" v-if="screenWidth <= 320">
                            <span :class="{
                                    'text-right': false,
                                    'text-success': item.status == 1 && item.status_expire == 1,
                                    'text-danger': item.status == 2,
                                }">
                                    <div v-if="item.status == 1">
                                        {{item.status_expire === 1 ? 'Đã duyệt' : 'Hết hạn'}}
                                    </div>
                                    <div v-else>{{item.status_text}}</div>
                            </span>
                        </div>
                        <div class="position-absolute actions-mobile" v-if="activeTr === index" :style="`width: ${widthTable}px`">
                            <div class="d-flex flex-wrap align-content-center justify-content-center" >
                                <div class="text-center fs-14px btn-reason" v-if="item.status == 2"
                                    @click="approve = item, dialogApprove = true">Xem lý do</div>
                                <div class="w-col" v-if="item.status == 1 && item.status_expire == 1">
                                    <button class="w-100 border-0 text-white rounded-lg fs-14px up-news"
                                        @click="upTop(item, index)" :disabled="index === loading && loadingAction == 'up-top'">
                                        Up lên đầu
                                    </button>
                                </div>
                                <div class="w-col" v-if="item.status == 1 && item.status_expire == 1">
                                    <button class="w-100 border-0 text-white rounded-lg fs-14px auto-up"
                                        @click="autoUp(item)">
                                        Tự động Up
                                    </button>
                                </div>
                                <div class="w-col" v-if="item.status == 1">
                                    <button class="w-100 border-0 text-white rounded-lg fs-14px up-time"
                                        @click="availability(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                                        Gia hạn
                                    </button>
                                </div>
                                <div class="w-col" v-if="item.status == 1 && item.status_expire == 1">
                                    <button class="w-100 border-0 text-white rounded-lg fs-14px up-vip"
                                        @click="actionUpItem(item, 'vip')">
                                        VIP
                                    </button>
                                </div>
                                <div class="w-col" v-if="item.status == 1 && item.status_expire == 1">
                                    <button class="w-100 border-0 text-white rounded-lg fs-14px up-svip"
                                        @click="actionUpItem(item, 'supper-vip')">
                                        Siêu VIP
                                    </button>
                                </div>
                                <div class="w-edit-delete" v-if="!(item.status == 1 && item.status_expire === 0)">
                                    <button class="border-0 text-white rounded-lg fs-14px btn-edit btn-success btn-block"
                                        @click="update(item.id)">
                                        <i class="icon ion-md-create"></i>
                                    </button>
                                </div>
                                <div class="w-edit-delete">
                                    <button class="border-0 text-white rounded-lg fs-14px btn-delete btn-danger btn-block"
                                        @click="destroy(item)">
                                        <i class="icon ion-md-trash"></i>
                                    </button>
                                </div>
                                <div class="w-50 px-1 w-cancel-detail">
                                    <button class="w-100 border-0 text-white text-dark rounded-lg fs-14px btn-cancel"
                                        @click="hiden()">
                                        Đóng
                                    </button>
                                </div>
                                <div class="w-50 px-1 w-cancel-detail" v-if="item.status == 1 && item.status_expire == 1">
                                    <a :href="$linkUrl(item.link)" target="_blank" class="btn w-100 border-0 text-primary rounded-lg fs-14px btn-detail bg-white">
                                        Xem chi tiết
                                    </a>
                                </div>

                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <!-- hết tbody mobile -->
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getData"/>

        <!-- khối dialog xử lý up vip, siêu vip -->
        <actionDialog
            :action="action"
            :visible.sync="dialog"
            :data="itemaction"
            :multiple="false"/>

        <ldc-dialog
            title="Lý do bị từ chối"
            :clickoutside="true"
            :class="{
                'modal-reason' : $detect == 'web',
                'modal-reason-mobile' : $detect == 'mobile'
                }"
            width="50%"
            :fullscreen="$detect == 'mobile'"
            :visible.sync="dialogApprove">
            <div v-html="approve.approve" v-if="approve && approve.approve" class="main-reason"></div>
            <p class="mb-0 p-3 fw-600" v-else>Lý do chưa xác định</p>
            <p class="mb-0 ps-reason px-3 pb-3 text-danger fw-600">Tham khảo:
                <a href="http://help.vatgia.com/quy-dinh-dang-rao-vat-n19/" target="_blank" class="ml-1 fw-400">Quy định đăng tin rao vặt</a>
            </p>
            <div class="footer-modal p-10px text-center">
                <button class="btn btn-success px-5"
                    v-if="approve"
                    @click="update(approve.id)">
                    <i class="icon ion-md-create mr-2"></i>Sửa tin
                </button>
            </div>
        </ldc-dialog>
    </div>
</template>
<script>
import { upTop, availability, destroy } from '@/config/raovat';
export default {
    components: {
        paginate: () => import('@/components/layout/pagination.vue'),
        actionTable: () => import('./fillter.vue'),
        actionDialog: () => import('@/components/profile/raovat/actionDialog.vue'),
    },
    data(){
        return {
            raovat: [], // data rao vặt
            activeTr: '', // hiện tại k sử dụng (check lại)
            current_page: 0, // page hiện tại
            next_page: 0, // next page
            last_page: 0, // last page
            idSelect: [], // id rao vặt select để sử lý muti
            data_fillter: {
                category: this.$route.query.category ? this.$route.query.category*1 : '',
                fillter: this.$route.query.fillter ? this.$route.query.fillter*1 : '',
                keyword: this.$route.query.keyword,
                page: this.$route.query.page ? this.$route.query.page*1 : '',
            }, // data fillter
            selectAll: false, // trạng thái có select all hay không
            dataActionItem: {}, // data xử lý đơn
            showModel: false, // show model xử lý đơn moblie
            screenWidth: window.screen.width, // lấy kích thước màn hình
            dialog: false, // show dialog xử lý up vip, up siêu vip
            action: '', // loại xử lý (up vip hoặc up siêu vip) để có giao diện khác
            itemaction: '', // data xử lý đơn
            loading: '', // loading theo tr
            loadingAction: '', // loading theo xử lý
            dialogApprove: false, //trạng thái bật lý do không được duyệt
            approve: null, // lý do không được phê duyệt
        }
    },
    created() {
        apiGet('/v2/profile/raovat', this.data_fillter).then(res => {
            let data = res.data;
            this.raovat = data.data;
            this.last_page = data.last_page;
            this.next_page = data.next_page;
            this.current_page = data.current_page;
            this.selectAll = false;
        });
        this.$eventBus.$on('call-rv-current-page', () => this.getData((this.current_page)))
    },
    methods: {
        /**
         *  lấy data rao vặt
         *
         *  page: page cần lấy dữu liệu
         */
        async getData(page){
            // lấy data fillter
            let fillter = {
                page: page,
                category: this.data_fillter.category,
                fillter: this.data_fillter.fillter,
                keyword: this.data_fillter.keyword,
                day_form: this.data_fillter.day_form,
                day_to: this.data_fillter.day_to,
            };
            let query = {};
            if(fillter.page) query.page = fillter.page;
            if(fillter.category) query.category = fillter.category;
            if(fillter.fillter) query.fillter = fillter.fillter;
            if(fillter.keyword) query.keyword = fillter.keyword;
            this.$router.push({
                name: 'raovat',
                query: query
            })
        },

        /**
         *  lấy data đẩy vào model xử lý đơn mobile
         */
        actionItem(item){
            this.dataActionItem = item;
            this.showModel = true;
        },

        /**
         * push id rao vặt mobile
         */
        pushIdMuti(item){
            if(item.status == 1 && item.status_expire === 1){
                if(this.idSelect.includes(item.id)){
                    let index = this.idSelect.indexOf(item.id);
                    this.idSelect.splice(index, 1);
                }else{
                    this.idSelect.push(item.id);
                }
            }
        },

        /**
         * xử lý đơn
         *
         * item: data xử lý
         * check: loại xử lý
         */
        actionUpItem(item, check){
            this.itemaction = item;
            this.action = check;
            this.dialog = true;
        },

        async upTop(item, index = null){
            this.loading = index;
            this.loadingAction = 'up-top';
            await upTop([item.id], this);
            this.loading = '';
            this.loadingAction = '';
            this.getData(this.current_page);
        },
        async availability(item, index = null){
            this.loading = index;
            this.loadingAction = 'availability';
            await availability([item.id], this);
            this.loading = '';
            this.loadingAction = '';
            this.getData(this.current_page);
        },
        destroy(item){
            destroy(item.id, this)
        },
        autoUp(item){
            this.$router.push({
                name: 'raovat-auto-up-show',
                query: {
                    id: item.id
                }
            })
        },
        hiden(){
            setTimeout(() => {
                this.activeTr = '';
            }, 0)
        },
        update(id){
            this.$router.push({
                name: 'raovat-update',
                params: {id: id}
            })
        }
    },
    watch: {
        query:{
            handler(val){
                apiGet('/v2/profile/raovat', {
                    category: val.category ? val.category*1 : '',
                    fillter: val.fillter ? val.fillter*1 : '',
                    keyword: val.keyword,
                    page: val.page ? val.page*1 : '',
                }).then(res => {
                    let data = res.data;
                    this.raovat = data.data;
                    this.last_page = data.last_page;
                    this.next_page = data.next_page;
                    this.current_page = data.current_page;
                    this.selectAll = false;
                });
            },
            deep: true
        },
        data_fillter: {
            handler(val){
                this.getData(1)
            },
            deep: true
        },
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.raovat.map(item => {
                    if(item.status == 1 && item.status_expire == 1){
                        this.idSelect.push(item.id);
                    }
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.raovat.map(item => {
                    if(item.status == 1 && item.status_expire == 1){
                        count += 1;
                    }
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
        showModel(val){
            if(!val){
                this.dataActionItem = {};
            }
        }
    },
    computed: {
        widthTable(){
            let table = document.querySelector('table');
            return table.clientWidth;
        },
        query(){
            return this.$route.query;
        }
    },
}
</script>
